<template>
  <div class="mainInputField">
    <label>{{ label }}</label>
    <div
      class="label-input"
      :class="`label-input--${type}`"
      v-html="value"
    ></div>
    <div v-if="errors" class="helperError">{{ errors[0] }}</div>
  </div>
</template>

<script>
export default {
  name: "LabelInput",
  components: {},
  props: {
    label: String,
    type: {
      type: String,
      default: "input", // 'input', 'textarea' ,
    },
    errors: Array,
    value: String,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
